// extracted by mini-css-extract-plugin
module.exports = {"not-found-wrapper":"not-found-page_not-found-wrapper__1GLyS"};